import React, { Component } from 'react';
import LogoLoader from './LogoLoader';
import './PreLaunchLoader.scss';

class PreLaunchLoader extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="prelaunch-container">
                <LogoLoader showSpinner={true}/>
            </div>
        );
    }
}

export default PreLaunchLoader;
